import React from 'react';
import {render} from 'react-dom';

import '../../website-ui/i18n/config';

import {ArticleThreadModal} from './article-thread-modal';

const renderCommentsModal = $container => {
  render(<ArticleThreadModal />, $container);
};

export {renderCommentsModal};
